<template>
  <v-app id="app">
    <Navbar />
    <v-main>
      <router-view />
    </v-main>
    <Footer />
    <AboutDialog v-if="isAboutDialog" @close="isAboutDialog = false" />
  </v-app>
</template>

<script>
import Navbar from "@/components/shared/Navbar";
import Footer from "@/components/shared/Footer";
import AboutDialog from "@/components/shared/AboutDialog";
export default {
  name: "App",
  components: {
    Navbar,
    Footer,
    AboutDialog,
  },

  data: () => ({
    isAboutDialog: false,
    isTrainingLengthDialog: false,
  }),
  created() {
    localStorage.setItem("app-version", 8);

    if (sessionStorage.getItem("is-about") === null) {
      this.isAboutDialog = true;
      sessionStorage.setItem("is-about", true);
    }
  },
  methods: {},
};
</script>

<style>
@font-face {
  font-family: "Oswald-Light";
  src: local("Oswald-Light.ttf"),
    url("./assets/Fonts/Oswald-Light.ttf") format("truetype");
}
h1,
h2,
h5 {
  font-family: Oswald-Light;
  color: rgb(79, 182, 227);
}
h1 {
  font-size: clamp(1rem, 7vw, 2rem);
}
html {
  scroll-behavior: smooth;
}
</style>
